import { Navigate, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { isGlobalAdmin } from "../../utils/util";
import { ManageUsersActions } from "./ManageUsersActions";
import { ManageUsersList } from "./ManageUsersList";
import { useGetEmployees, useGetEmployeesForSubCompanies } from "../../hooks/employeeHooks";
import { AdminCompanyFilter } from "../../components/AdminCompanyFilter";
import { SoecoHeader } from "../../components/SoecoHeader";
import { useContext, useEffect, useState } from "react";
import { EmployeeContext } from "../../context/EmployeeContext";
import { useGetCompanies, useGetSubCompanies } from "../../hooks/companyHooks";
import { SoecoButton } from "../../components/SoecoButton";

export const ManageUsers = () => {
    const [showSubCompanies, setShowSubCompanies] = useState(false);
    const { employee } = useContext(EmployeeContext);
    const { companyId } = useParams();
    const { data: employees } = useGetEmployees(companyId ?? "");
    const { data: companies } = useGetSubCompanies(companyId ?? "");
    const { data: subEmployees, isLoading } = useGetEmployeesForSubCompanies(
        showSubCompanies ? companies?.map(company => company.id) : [],
    );

    const employeesToShow = showSubCompanies
        ? [...(employees ?? []), ...(subEmployees ?? [])]
        : employees ?? [];

    const { data: allCompanies } = useGetCompanies();
    const soecoCompany = allCompanies?.find(c => c.name === "Soeco Kontorsmöbler");
    const ismaster = employee?.role === "admin" && soecoCompany?.id === employee?.companyId;
    const navigate = useNavigate();

    // TODO: It might be good to check if id is valid as well.
    if (!isGlobalAdmin) {
        return <Navigate to="/404" />;
    }

    const onChange = (idToNavigate: string) => {
        navigate(`/companies/${idToNavigate}/manageUsers`);
    };

    return (
        <ManageUsersPageWrapper>
            <SoecoHeader>Manage Users</SoecoHeader>
            {companyId && (isGlobalAdmin(employee) || !ismaster) && (
                <div style={{ display: "flex" }}>
                    <div style={{ flex: 3 }}>
                        <AdminCompanyFilter currentCompanyId={companyId} onChange={onChange} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <SoecoButton
                            size="small"
                            color={showSubCompanies ? "primary" : "warning"}
                            style={{ height: "90%" }}
                            onClick={() => {
                                setShowSubCompanies(!showSubCompanies);
                            }}
                        >
                            SHOW SUB COMPANIES
                        </SoecoButton>
                    </div>
                </div>
            )}

            <ManageUsersListWrapper>
                <ManageUsersList employee={employee} employees={employeesToShow ?? []} />
            </ManageUsersListWrapper>
            {companyId && <ManageUsersActions currentCompanyId={companyId} />}
        </ManageUsersPageWrapper>
    );
};

const ManageUsersPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 80vh;
    align-items: center;
    gap: 1rem;
`;

const ManageUsersListWrapper = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;
